export const NAV = [
  { key: "home", path: "/", en: "Home", ms: "Utama", icon: "LayoutDashboard" },
  { key: "hunter", path: "/hunter", en: "AI Market Hunter", ms: "Pemburu Pasaran AI", icon: "Radar" },
  { key: "signals", path: "/signals", en: "Signal History", ms: "Sejarah Isyarat", icon: "History" },
  { key: "buyable", path: "/buyable", en: "Can Buy Now", ms: "Boleh Beli", icon: "ShoppingCart" },
  { key: "autonomous", path: "/autonomous", en: "Autonomous Trading", ms: "Dagangan Autonomi", icon: "Bot" },
  { key: "terminal", path: "/terminal", en: "Multi-Chart Terminal", ms: "Terminal Multi-Carta", icon: "LayoutGrid" },
  { key: "patterns", path: "/patterns", en: "AI Pattern Analysis", ms: "Analisis Corak AI", icon: "Shapes" },
  { key: "predictive", path: "/predictive", en: "AI Predictive Engine", ms: "Enjin Ramalan AI", icon: "Activity" },
  { key: "portfolio", path: "/portfolio", en: "Portfolio", ms: "Portfolio", icon: "PieChart" },
  { key: "positions", path: "/positions", en: "Open Positions", ms: "Posisi Terbuka", icon: "Layers" },
  { key: "orders", path: "/orders", en: "Order History", ms: "Sejarah Pesanan", icon: "ListOrdered" },
  { key: "target", path: "/daily-target", en: "Daily Profit Target", ms: "Sasaran Untung Harian", icon: "Target" },
  { key: "shield", path: "/capital-shield", en: "Capital Shield", ms: "Perisai Modal", icon: "ShieldCheck" },
  { key: "brokers", path: "/brokers", en: "Broker Connections", ms: "Sambungan Broker", icon: "PlugZap" },
  { key: "moomoo", path: "/moomoo", en: "Moomoo Connection", ms: "Sambungan Moomoo", icon: "Link2" },
  { key: "backtesting", path: "/backtesting", en: "Backtesting", ms: "Ujian Balik", icon: "FlaskConical" },
  { key: "paper", path: "/paper-trading", en: "Paper Trading", ms: "Dagangan Kertas", icon: "FileText" },
  { key: "analytics", path: "/analytics", en: "Analytics", ms: "Analitik", icon: "BarChart3" },
  { key: "notifications", path: "/notifications", en: "Notifications", ms: "Notifikasi", icon: "Bell" },
  { key: "settings", path: "/settings", en: "Settings", ms: "Tetapan", icon: "Settings" },
  { key: "audit", path: "/audit-logs", en: "Audit Logs", ms: "Log Audit", icon: "ScrollText" },
  { key: "members", path: "/members", en: "Members", ms: "Ahli", icon: "Users" },
];

const D = {
  emergency_stop: ["EMERGENCY STOP", "HENTIAN KECEMASAN"],
  demo: ["DEMO · PAPER", "DEMO · KERTAS"],
  live: ["LIVE", "SEBENAR"],
  equity: ["Equity", "Ekuiti"],
  daily_pnl: ["Daily P&L", "Untung/Rugi Harian"],
  weekly_pnl: ["Weekly P&L", "Untung/Rugi Mingguan"],
  open_positions: ["Open positions", "Posisi terbuka"],
  no_trade: ["NO TRADE", "TIADA DAGANGAN"],
  logout: ["Logout", "Log keluar"],
  refresh: ["Refresh", "Muat semula"],
  disclaimer: ["Trading involves risk of loss. No profit is guaranteed. Scores are heuristic, not probabilities.",
    "Dagangan melibatkan risiko kerugian. Tiada keuntungan dijamin. Skor adalah heuristik, bukan kebarangkalian."],
  target: ["Daily target", "Sasaran harian"],
  shield: ["Capital Shield", "Perisai Modal"],
  market: ["Market", "Pasaran"],
};

export const t = (lang, key) => (D[key] ? D[key][lang === "ms" ? 1 : 0] : key);
